import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';

import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';

import Description from './ContentDetail/Description'
import Summary from './ContentDetail/Summary'
import Detail from './ContentDetail/Detail'

class ContentDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {

        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        return (

            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">
                    <Accordion expandTool={expandTool} horizontal className="practiceFlowResourcePane" enableKeyboardNavigation={false}>
                        <div tabTitle="Summary">
                            <div className="acc-header">Summary</div>
                            <Summary {...this.props} />
                        </div>
                        <div tabProps={{ title: 'Details' }}>
                            <div className="acc-header">Details</div>
                            <Detail {...this.props} />
                        </div>
                        <div tabProps={{ title: 'Description' }}>
                            <div className="acc-header">Description</div>
                            <Description {...this.props} />
                        </div>
                    </Accordion>
                </div>
            </div>
        )
    }
}

export default ContentDetail;